export default (props, {
  rhythm
}) => ({
  root: {
    margin: rhythm(-1),
    '& > *': {
      margin: rhythm(1)
    }
  }
})



// WEBPACK FOOTER //
// ./components/slices/FeaturedCharities/styles.js